// extracted by mini-css-extract-plugin
export var bodySections = "_8e-8";
export var gray = "_8e-7";
export var green = "_8e-4";
export var iconContainer = "_8e-9";
export var iconWidgetContainer = "_8e-1";
export var phoneIcon = "_8e-2";
export var red = "_8e-5";
export var statusDot = "_8e-3";
export var widgetContainer = "_8e-0";
export var yellow = "_8e-6";